{
    "productDashboard": {
        "common": {
            "last": "Ostatnie",
            "for": "Przez",
            "days": "dni",
            "day": "dzień",
            "categories": "kategorie",
            "open": "Otwarte",
            "inProgress": "W trakcie",
            "inProgressShort": "W trakcie",
            "resolved": "Rozwiązane",
            "clear": "Wyczyść",
            "selected": "wybrano",
            "clearAllFilters": "Wyczyść wszystkie filtry"
        },
        "shell": {
            "dataUpdated": "Dane zaktualizowane",
            "latestTurn": "ostatnia interakcja",
            "records": "rekordów",
            "ofData": "danych",
            "syncing": "Synchronizacja…",
            "refresh": "↻ Odśwież dane",
            "dataRefreshed": "Dane zostały odświeżone.",
            "syncFailed": "Nie udało się rozpocząć synchronizacji.",
            "syncCompletedWithErrors": "Synchronizacja zakończona z błędami:",
            "timeRangeAria": "Zakres czasu",
            "overview": "Przegląd",
            "myhelpData": "z danych MyHelp",
            "rangeLabel": "Zakres",
            "rangeAria": "Niestandardowy zakres dat",
            "rangeFrom": "Od",
            "rangeTo": "Do",
            "rangeApplyAria": "Zastosuj zakres dat",
            "rangeClearAria": "Wyczyść zakres dat",
            "rangeSelectBoth": "Wybierz datę początkową i końcową.",
            "rangeInvalidOrder": "Data początkowa musi być wcześniejsza niż data końcowa.",
            "rangeTooWide": "Wybierz zakres do",
            "dateRangeCaption": "Zakres dat"
        },
        "overview": {
            "greetingMorning": "Dzień dobry",
            "greetingAfternoon": "Dzień dobry",
            "greetingEvening": "Dobry wieczór",
            "greetingNight": "Dobranoc",
            "subtitle": "Oto, co dzieje się dziś w Twoich produktach.",
            "tabOverview": "Przegląd",
            "tabActionsForYou": "Działania dla Ciebie",
            "actionsTitle": "Działania dla Ciebie",
            "actionsMeta": "Zalecane kolejne kroki dla zespołu produktowego",
            "kpiTotalQueries": "ŁĄCZNA LICZBA ZAPYTAŃ",
            "kpiIncidentsRaised": "ZGŁOSZONE INCYDENTY (Od 10 września)",
            "kpiUpcoming": "NADCHODZĄCA FUNKCJA",
            "kpiCallback": "PROŚBY O ODDZWONIENIE (Od 10 września)",
            "kpiLiveChat": "PROŚBY O CZAT NA ŻYWO (Od 10 września)",
            "viewBreakdown": "Podział →",
            "viewAllIncidents": "Wszystkie incydenty →",
            "upcomingTitle": "Nowa funkcja już wkrótce",
            "upcomingSub": "Więcej informacji o produktach już wkrótce.",
            "topCategories": "Najczęstsze kategorie zapytań",
            "viewAll": "Zobacz wszystko →",
            "tipQueries": "Zapytania",
            "uniqueUsersTitle": "Unikalni użytkownicy",
            "detailedView": "Widok szczegółowy",
            "usersPerDay": "Unikalni użytkownicy dziennie",
            "usersPerWeek": "Unikalni użytkownicy tygodniowo",
            "usersPerMonth": "Unikalni użytkownicy miesięcznie",
            "uniqueUsersTrendTooltipLead": "Porównuje",
            "uniqueUsersTrendTooltipConnector": "z",
            "kpiTooltips": {
                "totalQueries": "Łączna liczba zapytań otrzymanych we wszystkich produktach w wybranym okresie.",
                "incidentsRaised": "Incydenty zgłoszone na podstawie rozmów z chatbotem, w podziale na status.",
                "upcoming": "Nowa funkcja panelu jest w przygotowaniu — sprawdź ponownie wkrótce.",
                "callback": "Prośby o oddzwonienie zgłoszone przez użytkowników, w podziale na język.",
                "liveChat": "Prośby o czat na żywo zgłoszone przez użytkowników, w podziale na język.",
                "feedbackCoverage": "Odsetek wszystkich zapytań, dla których otrzymano opinię użytkownika (👍 lub 👎)."
            }
        },
        "totalQueries": {
            "title": "Analiza łącznej liczby zapytań",
            "queries": "zapytania",
            "vsPrior": "w porównaniu z poprzednim okresem",
            "chartTitle": "Zapytania według kategorii",
            "breakdownTitle": "Podział na kategorie",
            "thCategory": "KATEGORIA",
            "thQueries": "ZAPYTANIA",
            "thShare": "UDZIAŁ",
            "thDistribution": "ROZKŁAD",
            "tipQueries": "Zapytania",
            "tipShare": "Udział %",
            "searchPlaceholder": "Szukaj",
            "matchesSuffix": "dopasowań",
            "matchSuffix": "dopasowanie"
        },
        "incidents": {
            "title": "Kategorie problemów",
            "incidents": "incydenty",
            "thId": "ID",
            "thIssue": "ZAPYTANIE / PROBLEM",
            "thCategory": "KATEGORIA",
            "thProduct": "PRODUKT",
            "thCompany": "FIRMA",
            "thSeverity": "WAŻNOŚĆ",
            "thStatus": "STATUS",
            "empty": "Brak incydentów MyHelp w tym okresie.",
            "severityHigh": "Wysoka",
            "severityMedium": "Średnia",
            "severityLow": "Niska",
            "incident": "incydent",
            "breakdownTitle": "Podział według kategorii",
            "thIncidents": "INCYDENTY",
            "thShare": "UDZIAŁ",
            "thDistribution": "ROZKŁAD",
            "searchPlaceholder": "Szukaj",
            "matchesSuffix": "dopasowań",
            "matchSuffix": "dopasowanie"
        },
        "incidentCategory": {
            "titlePrefix": "Incydenty w",
            "loadError": "Nie udało się załadować incydentów.",
            "incident": "incydent",
            "incidents": "incydenty",
            "closeAria": "Zamknij",
            "thDate": "DATA",
            "empty": "Nie znaleziono incydentów dla tej kategorii.",
            "loading": "Ładowanie…",
            "loadMorePrefix": "Załaduj więcej (pokazano",
            "of": "z"
        },
        "userSentiment": {
            "title": "Analiza opinii użytkowników",
            "summaryLikes": "polubienia",
            "summaryDislikes": "brak akceptacji",
            "last": "Ostatnie",
            "days": "dni",
            "likes": "Polubienia",
            "dislikes": "Brak akceptacji",
            "chartTitle": "Polubienia vs. brak akceptacji według kategorii",
            "detailTitle": "Szczegóły opinii według kategorii",
            "positive": "Pozytywne",
            "thingsWell": "Co poszło dobrze",
            "thingsAttention": "Co wymaga uwagi",
            "askAiHint": "Zapytaj asystenta AI o to (otwiera się w nowej karcie)",
            "searchPlaceholder": "Szukaj",
            "matchesSuffix": "dopasowań",
            "matchSuffix": "dopasowanie"
        },
        "products": {
            "title": "Kategorie produktów",
            "products": "produkty",
            "queryVolume": "Liczba zapytań",
            "incidents": "Incydenty",
            "sentiment": "Sentyment",
            "healthScore": "Wskaźnik kondycji"
        },
        "companyFilter": {
            "allCompanies": "Wszystkie firmy",
            "allCompaniesShort": "Wszystkie firmy",
            "selectedSuffix": "firm wybrano",
            "filterAria": "Filtruj według firmy",
            "searchPlaceholder": "Szukaj firm…",
            "noMatchPrefix": "Brak pasujących firm"
        },
        "clusterFilter": {
            "allClusters": "Wszystkie klastry",
            "allClustersShort": "Wszystkie klastry",
            "selectedSuffix": "klastrów wybrano",
            "filterAria": "Filtruj według klastra",
            "searchPlaceholder": "Szukaj klastrów…",
            "noMatchPrefix": "Brak pasujących klastrów"
        },
        "categoryFilter": {
            "allCategories": "Wszystkie kategorie",
            "selectedSuffix": "wybranych kategorii",
            "filterAria": "Filtruj według kategorii",
            "searchPlaceholder": "Szukaj kategorii…",
            "allCategoriesShort": "Wszystkie kategorie",
            "selectedShort": "wybrano",
            "clear": "Wyczyść",
            "noMatchPrefix": "Brak kategorii pasujących do"
        },
        "categoryQueries": {
            "like": "Lubię to",
            "dislike": "Nie lubię tego",
            "titlePrefix": "Zapytania w",
            "loadError": "Nie udało się załadować zapytań.",
            "query": "zapytanie",
            "queries": "zapytania",
            "preparing": "Przygotowywanie…",
            "downloadExcel": "⬇ Pobierz Excel",
            "closeAria": "Zamknij",
            "thQuery": "ZAPYTANIE",
            "thSentiment": "SENTYMENT",
            "thDate": "DATA",
            "thSource": "ŹRÓDŁO",
            "thLanguage": "JĘZYK",
            "thCompany": "FIRMA",
            "colQuery": "Zapytanie",
            "colSentiment": "Sentyment",
            "colDate": "Data",
            "colSource": "Źródło",
            "colLanguage": "Język",
            "colCompany": "Firma",
            "empty": "Nie znaleziono zapytań dla tej kategorii.",
            "loading": "Ładowanie…",
            "loadMorePrefix": "Załaduj więcej (wyświetlono",
            "of": "z",
            "sortSentimentHint": "Kliknij, aby posortować według sentymentu",
            "sortDateHint": "Kliknij, aby posortować według daty"
        },
        "feedbackPie": {
            "likes": "Polubienia",
            "dislikes": "Brak akceptacji",
            "noFeedback": "Brak opinii",
            "coverage": "ZASIĘG OPINII",
            "meta": "wszystkich zapytań",
            "feedback": "opinie",
            "noData": "Brak danych",
            "viewFeedback": "Opinie użytkowników →"
        },
        "requestCard": {
            "empty": "Brak zgłoszeń w tym okresie.",
            "breakdown": "Podział →"
        },
        "requestBreakdown": {
            "titleCallback": "Prośby o oddzwonienie — Podział według języka",
            "titleLiveChat": "Prośby o czat na żywo — Podział według języka",
            "breakdownTitle": "Podział według języka",
            "thLanguage": "JĘZYK",
            "thCount": "LICZBA",
            "thShare": "UDZIAŁ",
            "thDistribution": "ROZKŁAD",
            "language": "język",
            "languages": "języki",
            "request": "zgłoszenie",
            "requests": "zgłoszenia",
            "empty": "Brak zgłoszeń w tym okresie."
        },
        "tabError": {
            "title": "Nie udało się załadować danych panelu",
            "message": "Usługa danych nie odpowiedziała. Spróbuj ponownie — nie są wyświetlane żadne dane, więc nic tutaj nie jest szacowane."
        },
        "actionItems": {
            "knowledgeArticles": {
                "title": "Twórz / aktualizuj artykuły bazy wiedzy",
                "hint": "Dbaj o dokładność i aktualność treści swojego produktu",
                "childTitle": "Tworzenie i aktualizacja bazy wiedzy",
                "childHint": "Jak tworzyć i aktualizować bazę wiedzy."
            },
            "scripts": {
                "title": "Twórz i wdrażaj skrypty za pomocą Nexthink Remote Actions",
                "hint": "Zautomatyzuj rozwiązanie problemu, włączając zdalną akcję na urządzeniu użytkownika",
                "childTitle": "Link do zamówienia Nexthink",
                "childHint": "Zarządzanie akcjami zdalnymi"
            }
        }
    }
}
